import Vue from "vue";

/*
* supported type for toast:
* default
* primary
* secondary
* warning
* danger
* info
* success
*
* supported toaster:
* b-toaster-top-right
* b-toaster-top-left
* b-toaster-top-center
* b-toaster-top-full
* b-toaster-bottom-right
* b-toaster-bottom-left
* b-toaster-bottom-center
* b-toaster-bottom-full
*
* */
export const toast = (title, message, type = 'success', toaster = 'b-toaster-top-right') => {
    const vm = new Vue()
    vm.$bvToast.toast(`${message}`, {
        title: `${title}`,
        variant: type,
        headerClass: 'text-left w-100',
        bodyClass: 'text-right',
        toaster: toaster,
    })
};